module.exports = __webpack_public_path__ + "static/media/ssl.00cfc4ad.svg";